import {
  getDiscussionUrl,
  getResponseUrl
} from "@pathwright/web/src/modules/utils/urls"
import LibraryResourceContainerConnected from "../LibraryResourceContainer"

export default [
  {
    path: ":communityArea(discussion|members|activity)/",
    component: LibraryResourceContainerConnected,
    childRoutes: require("discussion/routes").default
  },
  {
    // redirecting legacy /community/feed/discussion/ route
    // to new /community/discussion/ route
    path: "feed/discussion/:discussionId/response?/:responseId(\\d+)?/",
    onEnter: (nextState, replaceState) =>
      replaceState({
        ...nextState.location,
        pathname: nextState.match.params.responseId
          ? getResponseUrl({
              resourceSlug: nextState.match.params.resourceSlug,
              groupId: nextState.match.params.cohortId,
              discussionId: nextState.match.params.discussionId,
              responseId: nextState.match.params.responseId
            })
          : getDiscussionUrl({
              resourceSlug: nextState.match.params.resourceSlug,
              groupId: nextState.match.params.cohortId,
              discussionId: nextState.match.params.discussionId
            })
      })
  }
]
